export const telemetryDetails = {
  '1200': 'wss://10.131.0.18:5000',
  '1210': 'wss://185.114.16.169:5000',
  '1110': 'wss://10.131.0.89:5000',
  '1120': 'wss://10.131.0.95:5000',
  local: 'wss://10.0.1.19:5000',
  SITL: 'wss://10.0.1.8:5000'
};
